// src/pages/Projects.jsx
import React, { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import Section from '../components/ui/Section';
import Heading from '../components/ui/Heading';
import Card from '../components/ui/Card';
import Button  from '../components/ui/Button';
import img from '../assets/vasudharini_banner.jpeg'

const Projects = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  // Sample data that would normally come from a CMS or API
  const projects = [
    {
      id: 'nest',
      title: 'The Nest Eco-Housing Project',
      description: 'Sustainable luxury living in harmony with nature. A community of 24 eco-friendly homes with shared green spaces.',
      location: 'Bangalore, Karnataka',
      category: 'Residential',
      year: '2022',
      image: img
    },
    {
      id: 'greenoffice',
      title: 'Green Office Complex',
      description: 'Net-zero energy office building featuring passive cooling, solar panels, and rainwater harvesting systems.',
      location: 'Chennai, Tamil Nadu',
      category: 'Commercial',
      year: '2020',
      image: img },
    {
      id: 'ecoretreat',
      title: 'EcoRetreat Wellness Center',
      description: 'A wellness retreat built with rammed earth and sustainable materials, blending with the surrounding landscape.',
      location: 'Munnar, Kerala',
      category: 'Hospitality',
      year: '2021',
      image: img},
    {
      id: 'ruralschool',
      title: 'Rural Education Campus',
      description: 'A solar-powered school designed for natural ventilation and using locally sourced materials.',
      location: 'Mandya, Karnataka',
      category: 'Educational',
      year: '2019',
      image: img }
  ];

  const categories = ['All', 'Residential', 'Commercial', 'Hospitality', 'Educational', 'Institutional'];

  return (
    <Layout>
      <Section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <Heading level="h1">Our Projects</Heading>
          <p className="text-xl text-gray-600 mt-4 max-w-3xl">
            Explore our portfolio of sustainable architecture projects across India, from eco-friendly residences to zero-energy commercial spaces.
          </p>
        </div>
      </Section>
      
      <Section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-4 py-2 rounded-full ${
                  index === 0 ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <Card key={project.id} className="overflow-hidden">
                <div className="h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-start">
                    <div>
                      <span className="text-sm text-primary-600 font-medium">{project.category}</span>
                      <h3 className="text-xl font-bold mt-1 mb-2">{project.title}</h3>
                    </div>
                    <span className="bg-gray-100 text-gray-900 text-sm px-3 py-1 rounded-full">
                      {project.year}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-4">{project.description}</p>
                  <div className="flex items-center text-gray-500 text-sm mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    {project.location}
                  </div>
                  <Button variant="outline" href={`/projects/${project.id}`}>View Project</Button>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </Section>
    </Layout>
  );
};

export default Projects;